// modules分成不同功能的模块
import Vue from 'vue';
import * as types from '../mutation-types.js';

const target = this;
const state = {
  cabinet: null,
  device: null,
  ip: null,
  bandwidth: null,
  ticket: null,
  bandwidthTraffic: null,
  alarm: null,
  alarmHistory: null,
  idcInspection: null,
  deviceInspection: null
};

const getters = {
  customInfo: state => state
};

const mutations = {
  [types.GET_CUSTOMINFO](state, res) {
    for (const key in res.value) {
      for (const subKey in res.value[key]) {
        if (res.value[key][subKey] == 'true' || res.value[key][subKey] == true) {
          res.value[key][subKey] = true;
        } else {
          res.value[key][subKey] = false;
        }
      }
    }
    state[res.type] = res.value;
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customInfo.js